import { format } from "date-fns";
import React, { useEffect } from "react";
import Timezones from "../../../assets/timezone-list.json";
import PropTypes from "prop-types";

const UserTimezone = ({ dueDate, timezone }) => {
  const [userTimezone, setUserTimezone] = React.useState(null);
  const [formattedDueDate, setFormattedDueDate] = React.useState(null);

  useEffect(() => {
    const selectedTimezone = Timezones.find((tz) => tz.value === timezone);
    setUserTimezone(selectedTimezone);
  }, [timezone]);

  useEffect(() => {
    if (!dueDate) return;
    const formattedDate = format(dueDate, "MMMM do, yyyy - hh:mm a");
    setFormattedDueDate(formattedDate);
  }, [dueDate]);

  return (
    <div>
      {timezone && dueDate && (
        <p className="m-0 user-timezone-text">
          🕒 Your time: {`${formattedDueDate} (${userTimezone?.name})`}
        </p>
      )}
    </div>
  );
};
UserTimezone.propTypes = {
  dueDate: PropTypes.instanceOf(Date),
  timezone: PropTypes.string,
};

export default UserTimezone;
